import { render, staticRenderFns } from "./CoassDetail.vue?vue&type=template&id=3a5440a0&"
import script from "./CoassDetail.vue?vue&type=script&lang=js&"
export * from "./CoassDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports